/* tslint:disable */
/* eslint-disable */
/**
 * Intranet - Boilerplate API
 * You need to change all the object names to your project ones
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BooleanResponse } from '../models';
// @ts-ignore
import type { CreateEmployeeRegimeTimeOffTypeCommand } from '../models';
// @ts-ignore
import type { CreateEmployeeTimeOffRegimeCommand } from '../models';
// @ts-ignore
import type { CreateEmployeeTimeOffStockCommand } from '../models';
// @ts-ignore
import type { CreateNonWorkingDayCommand } from '../models';
// @ts-ignore
import type { CreateTimeOffRegimeCommand } from '../models';
// @ts-ignore
import type { CreateTimeOffTypeCommand } from '../models';
// @ts-ignore
import type { DeleteEmployeeTimeOffStockCommand } from '../models';
// @ts-ignore
import type { EmployeeTimeOffRegimeDetailDtoResponse } from '../models';
// @ts-ignore
import type { EmployeeTimeOffRegimeResponse } from '../models';
// @ts-ignore
import type { EmployeeTimeOffRequestDtoResponse } from '../models';
// @ts-ignore
import type { EmployeeTimeOffRequestDtoSearchResponseResponse } from '../models';
// @ts-ignore
import type { EmployeeTimeOffStockDTOListResponse } from '../models';
// @ts-ignore
import type { EmployeeTimeOffStockDTOResponse } from '../models';
// @ts-ignore
import type { EmployeeTimeOffTypeDtoSearchResponseResponse } from '../models';
// @ts-ignore
import type { EventDTOSearchResponseResponse } from '../models';
// @ts-ignore
import type { Int32Response } from '../models';
// @ts-ignore
import type { ListOptionDTOSearchResponseResponse } from '../models';
// @ts-ignore
import type { NonWorkingDayResponse } from '../models';
// @ts-ignore
import type { NonWorkingDaySearchResponseResponse } from '../models';
// @ts-ignore
import type { StatusCodeResult } from '../models';
// @ts-ignore
import type { StringResponse } from '../models';
// @ts-ignore
import type { StringStringDictionaryResponse } from '../models';
// @ts-ignore
import type { TimeOffDTOResponse } from '../models';
// @ts-ignore
import type { TimeOffDTOSearchResponseResponse } from '../models';
// @ts-ignore
import type { TimeOffRegimeDTOResponse } from '../models';
// @ts-ignore
import type { TimeOffRegimeDTOSearchResponseResponse } from '../models';
// @ts-ignore
import type { TimeOffRequestTypeSearchResponseResponse } from '../models';
// @ts-ignore
import type { TimeOffTypeResponse } from '../models';
// @ts-ignore
import type { UnitResponse } from '../models';
// @ts-ignore
import type { UpdateEmployeeTimeOffStockCommand } from '../models';
// @ts-ignore
import type { UpdateNonWorkingDayCommand } from '../models';
// @ts-ignore
import type { UpdateTimeOffRegimeCommand } from '../models';
// @ts-ignore
import type { UpdateTimeOffTypeCommand } from '../models';
/**
 * TimeoffApi - axios parameter creator
 * @export
 */
export const TimeoffApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets Employee TimeOff Types by EmployeeRegime Id
         * @param {number} employeeRegimeId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet: async (employeeRegimeId: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeRegimeId' is not null or undefined
            assertParamExists('apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet', 'employeeRegimeId', employeeRegimeId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeRegimeTimeOffType/EmployeeRegime/{employeeRegimeId}`
                .replace(`{${"employeeRegimeId"}}`, window.customEncodeURIComponent(employeeRegimeId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new EmployeeRegimeTimeOffType.
         * @param {string} version 
         * @param {CreateEmployeeRegimeTimeOffTypeCommand} [createEmployeeRegimeTimeOffTypeCommand] The EmployeeRegimeTimeOffType creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeRegimeTimeOffTypePost: async (version: string, createEmployeeRegimeTimeOffTypeCommand?: CreateEmployeeRegimeTimeOffTypeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeRegimeTimeOffTypePost', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeRegimeTimeOffType`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeRegimeTimeOffTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an EmployeeTimeOffRegime by employee ID including related EmployeeRegimeTimeOffTypes, EmployeeTimeOffStocks
         * @param {number} employeeId The ID of the employee
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet: async (employeeId: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet', 'employeeId', employeeId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRegime/employee/{employeeId}`
                .replace(`{${"employeeId"}}`, window.customEncodeURIComponent(employeeId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an EmployeeTimeOffRegime by id. This will also soft delete all related EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
         * @param {number} id The ID of the EmployeeTimeOffRegime to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRegimeIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRegimeIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRegimeIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRegime/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New EmployeeTimeOffRegime. EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
         * @param {string} version 
         * @param {CreateEmployeeTimeOffRegimeCommand} [createEmployeeTimeOffRegimeCommand] The EmployeeTimeOffRegime creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRegimePost: async (version: string, createEmployeeTimeOffRegimeCommand?: CreateEmployeeTimeOffRegimeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRegimePost', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRegime`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeTimeOffRegimeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a TimeOff\'s attached file (requires userentity header)
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestFileDelete: async (version: string, id?: number, key?: string, employeeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestFileDelete', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRequest/file`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a TimeOff\'s attached file
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestFileGet: async (version: string, id?: number, key?: string, employeeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestFileGet', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRequest/file`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a EmployeeTimeOffRequest by Id (requires userentity header)
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestIdGet', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRequest/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New EmployeeTimeOffRequest.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestPost: async (version: string, commandJson?: string, uploads?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestPost', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRequest`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (commandJson !== undefined) { 
                localVarFormParams.append('commandJson', commandJson as any);
            }
                if (uploads) {
                uploads.forEach((element) => {
                    localVarFormParams.append('uploads', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an EmployeeTimeOffRequest.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [keysForDeletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestPut: async (version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestPut', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRequest`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (commandJson !== undefined) { 
                localVarFormParams.append('commandJson', commandJson as any);
            }
                if (uploads) {
                uploads.forEach((element) => {
                    localVarFormParams.append('uploads', element as any);
                })
            }

                if (keysForDeletion) {
                keysForDeletion.forEach((element) => {
                    localVarFormParams.append('keysForDeletion', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches everyone\'s time offs with visible states. If client, then your employees time off.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [term] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {number} [userEntityId] 
         * @param {number} [employeeId] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestSearchGet: async (version: string, pageNum?: number, pageSize?: number, term?: string, sort?: string, order?: string, userEntityId?: number, employeeId?: number, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestSearchGet', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRequest/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (userEntityId !== undefined) {
                localVarQueryParameter['userEntityId'] = userEntityId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches your time offs with visible states. If client, then your employees time off.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestSearchMineGet: async (version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffRequestSearchMineGet', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffRequest/search/mine`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an EmployeeTimeOffStock.
         * @param {string} version 
         * @param {DeleteEmployeeTimeOffStockCommand} [deleteEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffStockDelete: async (version: string, deleteEmployeeTimeOffStockCommand?: DeleteEmployeeTimeOffStockCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffStockDelete', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffStock`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteEmployeeTimeOffStockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new EmployeeTimeOffStock.
         * @param {string} version 
         * @param {CreateEmployeeTimeOffStockCommand} [createEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffStockPost: async (version: string, createEmployeeTimeOffStockCommand?: CreateEmployeeTimeOffStockCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffStockPost', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffStock`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeTimeOffStockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a new EmployeeTimeOffStock.
         * @param {string} version 
         * @param {UpdateEmployeeTimeOffStockCommand} [updateEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffStockPut: async (version: string, updateEmployeeTimeOffStockCommand?: UpdateEmployeeTimeOffStockCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEmployeeTimeOffStockPut', 'version', version)
            const localVarPath = `/api/v{version}/EmployeeTimeOffStock`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeTimeOffStockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Events relevant to user.This is for Dashboard Calendar
         * @param {string} version 
         * @param {Date} [start] 
         * @param {Date} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEventAllGet: async (version: string, start?: Date, end?: Date, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEventAllGet', 'version', version)
            const localVarPath = `/api/v{version}/Event/all`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for all Events. Useful for filtering events.
         * @param {string} version 
         * @param {string} [term] 
         * @param {string} [order] 
         * @param {string} [eventType] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEventSearchGet: async (version: string, term?: string, order?: string, eventType?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionEventSearchGet', 'version', version)
            const localVarPath = `/api/v{version}/Event/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets employee time off stock name
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet: async (employeeRegimeId: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeRegimeId' is not null or undefined
            assertParamExists('apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet', 'employeeRegimeId', employeeRegimeId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet', 'version', version)
            const localVarPath = `/api/v{version}/List/employeeTimeOffStockName/{employeeRegimeId}`
                .replace(`{${"employeeRegimeId"}}`, window.customEncodeURIComponent(employeeRegimeId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets employee time off types list for a specific employee regime
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet: async (employeeRegimeId: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeRegimeId' is not null or undefined
            assertParamExists('apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet', 'employeeRegimeId', employeeRegimeId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet', 'version', version)
            const localVarPath = `/api/v{version}/List/employeeTimeOffTypes/{employeeRegimeId}`
                .replace(`{${"employeeRegimeId"}}`, window.customEncodeURIComponent(employeeRegimeId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary regime ListOptionDto
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListRegimeGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListRegimeGet', 'version', version)
            const localVarPath = `/api/v{version}/List/regime`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary requestType ListOptionDto
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListRequestTypeGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListRequestTypeGet', 'version', version)
            const localVarPath = `/api/v{version}/List/requestType`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets time off types list for a specific employee regime  Returns TimeOffType.Id instead of EmployeeRegimeTimeOffType.Id
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet: async (employeeRegimeId: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeRegimeId' is not null or undefined
            assertParamExists('apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet', 'employeeRegimeId', employeeRegimeId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet', 'version', version)
            const localVarPath = `/api/v{version}/List/timeOffTypesByEmployeeRegime/{employeeRegimeId}`
                .replace(`{${"employeeRegimeId"}}`, window.customEncodeURIComponent(employeeRegimeId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of time off types grouped by their regimes
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListTimeOffTypesByRegimeGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListTimeOffTypesByRegimeGet', 'version', version)
            const localVarPath = `/api/v{version}/List/timeOffTypesByRegime`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the list of all NonWorkingDays
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayAllGet: async (version: string, pageNum?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNonWorkingDayAllGet', 'version', version)
            const localVarPath = `/api/v{version}/NonWorkingDay/all`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a NonWorkingDay by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionNonWorkingDayIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNonWorkingDayIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/NonWorkingDay/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an NonWorkingDay by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionNonWorkingDayIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNonWorkingDayIdGet', 'version', version)
            const localVarPath = `/api/v{version}/NonWorkingDay/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New NonWorkingDay.
         * @param {string} version 
         * @param {CreateNonWorkingDayCommand} [createNonWorkingDayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayPost: async (version: string, createNonWorkingDayCommand?: CreateNonWorkingDayCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNonWorkingDayPost', 'version', version)
            const localVarPath = `/api/v{version}/NonWorkingDay`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNonWorkingDayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a NonWorkingDay.
         * @param {string} version 
         * @param {UpdateNonWorkingDayCommand} [updateNonWorkingDayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayPut: async (version: string, updateNonWorkingDayCommand?: UpdateNonWorkingDayCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNonWorkingDayPut', 'version', version)
            const localVarPath = `/api/v{version}/NonWorkingDay`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNonWorkingDayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for NonWorkingDays
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDaySearchGet: async (version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNonWorkingDaySearchGet', 'version', version)
            const localVarPath = `/api/v{version}/NonWorkingDay/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a TimeOff\'s attached file (requires userentity header)
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffFileDelete: async (version: string, id?: number, key?: string, employeeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffFileDelete', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff/file`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a TimeOff\'s attached file
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffFileGet: async (version: string, id?: number, key?: string, employeeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffFileGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff/file`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a TimeOff by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTimeOffIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a TimeOff by Id (requires userentity header)
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTimeOffIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffIdGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New TimeOff.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffPost: async (version: string, commandJson?: string, uploads?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffPost', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (commandJson !== undefined) { 
                localVarFormParams.append('commandJson', commandJson as any);
            }
                if (uploads) {
                uploads.forEach((element) => {
                    localVarFormParams.append('uploads', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing TimeOff.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [keysForDeletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffPut: async (version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffPut', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (commandJson !== undefined) { 
                localVarFormParams.append('commandJson', commandJson as any);
            }
                if (uploads) {
                uploads.forEach((element) => {
                    localVarFormParams.append('uploads', element as any);
                })
            }

                if (keysForDeletion) {
                keysForDeletion.forEach((element) => {
                    localVarFormParams.append('keysForDeletion', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets an existing TimeOffRegime to Active.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeIdActivatePatch: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimeIdActivatePatch', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimeIdActivatePatch', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffRegime/{id}/activate`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing TimeOffRegime.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimeIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimeIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffRegime/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a TimeOffRegime by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimeIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimeIdGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffRegime/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New TimeOffRegime.
         * @param {string} version 
         * @param {CreateTimeOffRegimeCommand} [createTimeOffRegimeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimePost: async (version: string, createTimeOffRegimeCommand?: CreateTimeOffRegimeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimePost', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffRegime`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTimeOffRegimeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing TimeOffRegime.
         * @param {string} version 
         * @param {UpdateTimeOffRegimeCommand} [updateTimeOffRegimeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimePut: async (version: string, updateTimeOffRegimeCommand?: UpdateTimeOffRegimeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimePut', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffRegime`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTimeOffRegimeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for TimeOffRegimes
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {boolean} [includeInactive] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeSearchGet: async (version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffRegimeSearchGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffRegime/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the list of all TimeOffRequestTypes
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRequestTypeAllGet: async (version: string, pageNum?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffRequestTypeAllGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffRequestType/all`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for a TimeOff (request)
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {boolean} [includeInactive] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffSearchGet: async (version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffSearchGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for a TimeOff (request)
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffSearchMineGet: async (version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffSearchMineGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOff/search/mine`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a TimeOffType by Id.
         * @param {number} id The Id of the TimeOffType to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypeIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTimeOffTypeIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffTypeIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffType/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a TimeOffType by Id.
         * @param {number} id The Id of the TimeOffType to retrieve
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypeIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTimeOffTypeIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffTypeIdGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffType/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New TimeOffType.
         * @param {string} version 
         * @param {CreateTimeOffTypeCommand} [createTimeOffTypeCommand] The TimeOffType creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypePost: async (version: string, createTimeOffTypeCommand?: CreateTimeOffTypeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffTypePost', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffType`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTimeOffTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing TimeOffType.
         * @param {string} version 
         * @param {UpdateTimeOffTypeCommand} [updateTimeOffTypeCommand] The TimeOffType update command containing the Id and properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypePut: async (version: string, updateTimeOffTypeCommand?: UpdateTimeOffTypeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffTypePut', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffType`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTimeOffTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for TimeOffTypes by regimeId
         * @param {string} version 
         * @param {number} [regimeId] 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypeSearchGet: async (version: string, regimeId?: number, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTimeOffTypeSearchGet', 'version', version)
            const localVarPath = `/api/v{version}/TimeOffType/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
           

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (regimeId !== undefined) {
                localVarQueryParameter['regimeId'] = regimeId;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeoffApi - functional programming interface
 * @export
 */
export const TimeoffApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeoffApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets Employee TimeOff Types by EmployeeRegime Id
         * @param {number} employeeRegimeId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffTypeDtoSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new EmployeeRegimeTimeOffType.
         * @param {string} version 
         * @param {CreateEmployeeRegimeTimeOffTypeCommand} [createEmployeeRegimeTimeOffTypeCommand] The EmployeeRegimeTimeOffType creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeRegimeTimeOffTypePost(version: string, createEmployeeRegimeTimeOffTypeCommand?: CreateEmployeeRegimeTimeOffTypeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffStockDTOListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeRegimeTimeOffTypePost(version, createEmployeeRegimeTimeOffTypeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeRegimeTimeOffTypePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets an EmployeeTimeOffRegime by employee ID including related EmployeeRegimeTimeOffTypes, EmployeeTimeOffStocks
         * @param {number} employeeId The ID of the employee
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet(employeeId: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffRegimeDetailDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet(employeeId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes an EmployeeTimeOffRegime by id. This will also soft delete all related EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
         * @param {number} id The ID of the EmployeeTimeOffRegime to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRegimeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRegimeIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRegimeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New EmployeeTimeOffRegime. EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
         * @param {string} version 
         * @param {CreateEmployeeTimeOffRegimeCommand} [createEmployeeTimeOffRegimeCommand] The EmployeeTimeOffRegime creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRegimePost(version: string, createEmployeeTimeOffRegimeCommand?: CreateEmployeeTimeOffRegimeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffRegimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRegimePost(version, createEmployeeTimeOffRegimeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRegimePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a TimeOff\'s attached file (requires userentity header)
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRequestFileDelete(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRequestFileDelete(version, id, key, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRequestFileDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a TimeOff\'s attached file
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRequestFileGet(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringStringDictionaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRequestFileGet(version, id, key, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRequestFileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a EmployeeTimeOffRequest by Id (requires userentity header)
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRequestIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffRequestDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRequestIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRequestIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New EmployeeTimeOffRequest.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRequestPost(version: string, commandJson?: string, uploads?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffRequestDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRequestPost(version, commandJson, uploads, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRequestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an EmployeeTimeOffRequest.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [keysForDeletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRequestPut(version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffRequestDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRequestPut(version, commandJson, uploads, keysForDeletion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRequestPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches everyone\'s time offs with visible states. If client, then your employees time off.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [term] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {number} [userEntityId] 
         * @param {number} [employeeId] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRequestSearchGet(version: string, pageNum?: number, pageSize?: number, term?: string, sort?: string, order?: string, userEntityId?: number, employeeId?: number, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffRequestDtoSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRequestSearchGet(version, pageNum, pageSize, term, sort, order, userEntityId, employeeId, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRequestSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches your time offs with visible states. If client, then your employees time off.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffRequestSearchMineGet(version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffRequestDtoSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffRequestSearchMineGet(version, pageNum, pageSize, sort, order, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffRequestSearchMineGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes an EmployeeTimeOffStock.
         * @param {string} version 
         * @param {DeleteEmployeeTimeOffStockCommand} [deleteEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffStockDelete(version: string, deleteEmployeeTimeOffStockCommand?: DeleteEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffStockDelete(version, deleteEmployeeTimeOffStockCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffStockDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new EmployeeTimeOffStock.
         * @param {string} version 
         * @param {CreateEmployeeTimeOffStockCommand} [createEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffStockPost(version: string, createEmployeeTimeOffStockCommand?: CreateEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffStockDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffStockPost(version, createEmployeeTimeOffStockCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffStockPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a new EmployeeTimeOffStock.
         * @param {string} version 
         * @param {UpdateEmployeeTimeOffStockCommand} [updateEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEmployeeTimeOffStockPut(version: string, updateEmployeeTimeOffStockCommand?: UpdateEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeOffStockDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEmployeeTimeOffStockPut(version, updateEmployeeTimeOffStockCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEmployeeTimeOffStockPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all Events relevant to user.This is for Dashboard Calendar
         * @param {string} version 
         * @param {Date} [start] 
         * @param {Date} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEventAllGet(version: string, start?: Date, end?: Date, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEventAllGet(version, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEventAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for all Events. Useful for filtering events.
         * @param {string} version 
         * @param {string} [term] 
         * @param {string} [order] 
         * @param {string} [eventType] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionEventSearchGet(version: string, term?: string, order?: string, eventType?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionEventSearchGet(version, term, order, eventType, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionEventSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets employee time off stock name
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet(employeeRegimeId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets employee time off types list for a specific employee regime
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet(employeeRegimeId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary regime ListOptionDto
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListRegimeGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListRegimeGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionListRegimeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary requestType ListOptionDto
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListRequestTypeGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListRequestTypeGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionListRequestTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets time off types list for a specific employee regime  Returns TimeOffType.Id instead of EmployeeRegimeTimeOffType.Id
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of time off types grouped by their regimes
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListTimeOffTypesByRegimeGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListTimeOffTypesByRegimeGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionListTimeOffTypesByRegimeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the list of all NonWorkingDays
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNonWorkingDayAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonWorkingDaySearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNonWorkingDayAllGet(version, pageNum, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionNonWorkingDayAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a NonWorkingDay by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNonWorkingDayIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNonWorkingDayIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionNonWorkingDayIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets an NonWorkingDay by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNonWorkingDayIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonWorkingDayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNonWorkingDayIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionNonWorkingDayIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New NonWorkingDay.
         * @param {string} version 
         * @param {CreateNonWorkingDayCommand} [createNonWorkingDayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNonWorkingDayPost(version: string, createNonWorkingDayCommand?: CreateNonWorkingDayCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonWorkingDayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNonWorkingDayPost(version, createNonWorkingDayCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionNonWorkingDayPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a NonWorkingDay.
         * @param {string} version 
         * @param {UpdateNonWorkingDayCommand} [updateNonWorkingDayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNonWorkingDayPut(version: string, updateNonWorkingDayCommand?: UpdateNonWorkingDayCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonWorkingDayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNonWorkingDayPut(version, updateNonWorkingDayCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionNonWorkingDayPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for NonWorkingDays
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNonWorkingDaySearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonWorkingDaySearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNonWorkingDaySearchGet(version, term, pageNum, pageSize, sort, order, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionNonWorkingDaySearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a TimeOff\'s attached file (requires userentity header)
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffFileDelete(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffFileDelete(version, id, key, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffFileDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a TimeOff\'s attached file
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffFileGet(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringStringDictionaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffFileGet(version, id, key, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffFileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a TimeOff by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a TimeOff by Id (requires userentity header)
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New TimeOff.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffPost(version: string, commandJson?: string, uploads?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffPost(version, commandJson, uploads, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing TimeOff.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [keysForDeletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffPut(version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffPut(version, commandJson, uploads, keysForDeletion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sets an existing TimeOffRegime to Active.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffRegimeIdActivatePatch(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffRegimeIdActivatePatch(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffRegimeIdActivatePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing TimeOffRegime.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffRegimeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffRegimeIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffRegimeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a TimeOffRegime by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffRegimeIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffRegimeDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffRegimeIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffRegimeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New TimeOffRegime.
         * @param {string} version 
         * @param {CreateTimeOffRegimeCommand} [createTimeOffRegimeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffRegimePost(version: string, createTimeOffRegimeCommand?: CreateTimeOffRegimeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffRegimePost(version, createTimeOffRegimeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffRegimePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing TimeOffRegime.
         * @param {string} version 
         * @param {UpdateTimeOffRegimeCommand} [updateTimeOffRegimeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffRegimePut(version: string, updateTimeOffRegimeCommand?: UpdateTimeOffRegimeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusCodeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffRegimePut(version, updateTimeOffRegimeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffRegimePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for TimeOffRegimes
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {boolean} [includeInactive] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffRegimeSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffRegimeDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffRegimeSearchGet(version, term, pageNum, pageSize, sort, order, includeInactive, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffRegimeSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the list of all TimeOffRequestTypes
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffRequestTypeAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffRequestTypeSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffRequestTypeAllGet(version, pageNum, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffRequestTypeAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for a TimeOff (request)
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {boolean} [includeInactive] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffSearchGet(version, term, pageNum, pageSize, sort, order, includeInactive, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for a TimeOff (request)
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffSearchMineGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffSearchMineGet(version, term, pageNum, pageSize, sort, order, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffSearchMineGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a TimeOffType by Id.
         * @param {number} id The Id of the TimeOffType to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffTypeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffTypeIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a TimeOffType by Id.
         * @param {number} id The Id of the TimeOffType to retrieve
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffTypeIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffTypeIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New TimeOffType.
         * @param {string} version 
         * @param {CreateTimeOffTypeCommand} [createTimeOffTypeCommand] The TimeOffType creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffTypePost(version: string, createTimeOffTypeCommand?: CreateTimeOffTypeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffTypePost(version, createTimeOffTypeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffTypePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing TimeOffType.
         * @param {string} version 
         * @param {UpdateTimeOffTypeCommand} [updateTimeOffTypeCommand] The TimeOffType update command containing the Id and properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffTypePut(version: string, updateTimeOffTypeCommand?: UpdateTimeOffTypeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffTypePut(version, updateTimeOffTypeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffTypePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for TimeOffTypes by regimeId
         * @param {string} version 
         * @param {number} [regimeId] 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTimeOffTypeSearchGet(version: string, regimeId?: number, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeOffRegimeDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTimeOffTypeSearchGet(version, regimeId, term, pageNum, pageSize, sort, order, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeoffApi.apiVversionTimeOffTypeSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TimeoffApi - factory interface
 * @export
 */
export const TimeoffApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeoffApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets Employee TimeOff Types by EmployeeRegime Id
         * @param {number} employeeRegimeId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffTypeDtoSearchResponseResponse> {
            return localVarFp.apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new EmployeeRegimeTimeOffType.
         * @param {string} version 
         * @param {CreateEmployeeRegimeTimeOffTypeCommand} [createEmployeeRegimeTimeOffTypeCommand] The EmployeeRegimeTimeOffType creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeRegimeTimeOffTypePost(version: string, createEmployeeRegimeTimeOffTypeCommand?: CreateEmployeeRegimeTimeOffTypeCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffStockDTOListResponse> {
            return localVarFp.apiVversionEmployeeRegimeTimeOffTypePost(version, createEmployeeRegimeTimeOffTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an EmployeeTimeOffRegime by employee ID including related EmployeeRegimeTimeOffTypes, EmployeeTimeOffStocks
         * @param {number} employeeId The ID of the employee
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet(employeeId: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffRegimeDetailDtoResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet(employeeId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an EmployeeTimeOffRegime by id. This will also soft delete all related EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
         * @param {number} id The ID of the EmployeeTimeOffRegime to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRegimeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRegimeIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New EmployeeTimeOffRegime. EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
         * @param {string} version 
         * @param {CreateEmployeeTimeOffRegimeCommand} [createEmployeeTimeOffRegimeCommand] The EmployeeTimeOffRegime creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRegimePost(version: string, createEmployeeTimeOffRegimeCommand?: CreateEmployeeTimeOffRegimeCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffRegimeResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRegimePost(version, createEmployeeTimeOffRegimeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a TimeOff\'s attached file (requires userentity header)
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestFileDelete(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRequestFileDelete(version, id, key, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a TimeOff\'s attached file
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestFileGet(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<StringStringDictionaryResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRequestFileGet(version, id, key, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a EmployeeTimeOffRequest by Id (requires userentity header)
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffRequestDtoResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRequestIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New EmployeeTimeOffRequest.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestPost(version: string, commandJson?: string, uploads?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffRequestDtoResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRequestPost(version, commandJson, uploads, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an EmployeeTimeOffRequest.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [keysForDeletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestPut(version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffRequestDtoResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRequestPut(version, commandJson, uploads, keysForDeletion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches everyone\'s time offs with visible states. If client, then your employees time off.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [term] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {number} [userEntityId] 
         * @param {number} [employeeId] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestSearchGet(version: string, pageNum?: number, pageSize?: number, term?: string, sort?: string, order?: string, userEntityId?: number, employeeId?: number, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffRequestDtoSearchResponseResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRequestSearchGet(version, pageNum, pageSize, term, sort, order, userEntityId, employeeId, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches your time offs with visible states. If client, then your employees time off.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffRequestSearchMineGet(version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffRequestDtoSearchResponseResponse> {
            return localVarFp.apiVversionEmployeeTimeOffRequestSearchMineGet(version, pageNum, pageSize, sort, order, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an EmployeeTimeOffStock.
         * @param {string} version 
         * @param {DeleteEmployeeTimeOffStockCommand} [deleteEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffStockDelete(version: string, deleteEmployeeTimeOffStockCommand?: DeleteEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionEmployeeTimeOffStockDelete(version, deleteEmployeeTimeOffStockCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new EmployeeTimeOffStock.
         * @param {string} version 
         * @param {CreateEmployeeTimeOffStockCommand} [createEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffStockPost(version: string, createEmployeeTimeOffStockCommand?: CreateEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffStockDTOResponse> {
            return localVarFp.apiVversionEmployeeTimeOffStockPost(version, createEmployeeTimeOffStockCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a new EmployeeTimeOffStock.
         * @param {string} version 
         * @param {UpdateEmployeeTimeOffStockCommand} [updateEmployeeTimeOffStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEmployeeTimeOffStockPut(version: string, updateEmployeeTimeOffStockCommand?: UpdateEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTimeOffStockDTOResponse> {
            return localVarFp.apiVversionEmployeeTimeOffStockPut(version, updateEmployeeTimeOffStockCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Events relevant to user.This is for Dashboard Calendar
         * @param {string} version 
         * @param {Date} [start] 
         * @param {Date} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEventAllGet(version: string, start?: Date, end?: Date, options?: RawAxiosRequestConfig): AxiosPromise<EventDTOSearchResponseResponse> {
            return localVarFp.apiVversionEventAllGet(version, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for all Events. Useful for filtering events.
         * @param {string} version 
         * @param {string} [term] 
         * @param {string} [order] 
         * @param {string} [eventType] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionEventSearchGet(version: string, term?: string, order?: string, eventType?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<EventDTOSearchResponseResponse> {
            return localVarFp.apiVversionEventSearchGet(version, term, order, eventType, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets employee time off stock name
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets employee time off types list for a specific employee regime
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary regime ListOptionDto
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListRegimeGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListRegimeGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary requestType ListOptionDto
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListRequestTypeGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListRequestTypeGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets time off types list for a specific employee regime  Returns TimeOffType.Id instead of EmployeeRegimeTimeOffType.Id
         * @param {number} employeeRegimeId The ID of the employee regime
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of time off types grouped by their regimes
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListTimeOffTypesByRegimeGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListTimeOffTypesByRegimeGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the list of all NonWorkingDays
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<NonWorkingDaySearchResponseResponse> {
            return localVarFp.apiVversionNonWorkingDayAllGet(version, pageNum, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a NonWorkingDay by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<UnitResponse> {
            return localVarFp.apiVversionNonWorkingDayIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an NonWorkingDay by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<NonWorkingDayResponse> {
            return localVarFp.apiVversionNonWorkingDayIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New NonWorkingDay.
         * @param {string} version 
         * @param {CreateNonWorkingDayCommand} [createNonWorkingDayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayPost(version: string, createNonWorkingDayCommand?: CreateNonWorkingDayCommand, options?: RawAxiosRequestConfig): AxiosPromise<NonWorkingDayResponse> {
            return localVarFp.apiVversionNonWorkingDayPost(version, createNonWorkingDayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a NonWorkingDay.
         * @param {string} version 
         * @param {UpdateNonWorkingDayCommand} [updateNonWorkingDayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDayPut(version: string, updateNonWorkingDayCommand?: UpdateNonWorkingDayCommand, options?: RawAxiosRequestConfig): AxiosPromise<NonWorkingDayResponse> {
            return localVarFp.apiVversionNonWorkingDayPut(version, updateNonWorkingDayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for NonWorkingDays
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNonWorkingDaySearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<NonWorkingDaySearchResponseResponse> {
            return localVarFp.apiVversionNonWorkingDaySearchGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a TimeOff\'s attached file (requires userentity header)
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffFileDelete(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionTimeOffFileDelete(version, id, key, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a TimeOff\'s attached file
         * @param {string} version 
         * @param {number} [id] 
         * @param {string} [key] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffFileGet(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<StringStringDictionaryResponse> {
            return localVarFp.apiVversionTimeOffFileGet(version, id, key, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a TimeOff by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionTimeOffIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a TimeOff by Id (requires userentity header)
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffDTOResponse> {
            return localVarFp.apiVversionTimeOffIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New TimeOff.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffPost(version: string, commandJson?: string, uploads?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffDTOResponse> {
            return localVarFp.apiVversionTimeOffPost(version, commandJson, uploads, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing TimeOff.
         * @param {string} version 
         * @param {string} [commandJson] 
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [keysForDeletion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffPut(version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffDTOResponse> {
            return localVarFp.apiVversionTimeOffPut(version, commandJson, uploads, keysForDeletion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets an existing TimeOffRegime to Active.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeIdActivatePatch(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<Int32Response> {
            return localVarFp.apiVversionTimeOffRegimeIdActivatePatch(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing TimeOffRegime.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<Int32Response> {
            return localVarFp.apiVversionTimeOffRegimeIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a TimeOffRegime by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffRegimeDTOResponse> {
            return localVarFp.apiVversionTimeOffRegimeIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New TimeOffRegime.
         * @param {string} version 
         * @param {CreateTimeOffRegimeCommand} [createTimeOffRegimeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimePost(version: string, createTimeOffRegimeCommand?: CreateTimeOffRegimeCommand, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffDTOResponse> {
            return localVarFp.apiVversionTimeOffRegimePost(version, createTimeOffRegimeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing TimeOffRegime.
         * @param {string} version 
         * @param {UpdateTimeOffRegimeCommand} [updateTimeOffRegimeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimePut(version: string, updateTimeOffRegimeCommand?: UpdateTimeOffRegimeCommand, options?: RawAxiosRequestConfig): AxiosPromise<StatusCodeResult> {
            return localVarFp.apiVversionTimeOffRegimePut(version, updateTimeOffRegimeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for TimeOffRegimes
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {boolean} [includeInactive] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRegimeSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffRegimeDTOSearchResponseResponse> {
            return localVarFp.apiVversionTimeOffRegimeSearchGet(version, term, pageNum, pageSize, sort, order, includeInactive, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the list of all TimeOffRequestTypes
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffRequestTypeAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffRequestTypeSearchResponseResponse> {
            return localVarFp.apiVversionTimeOffRequestTypeAllGet(version, pageNum, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for a TimeOff (request)
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {boolean} [includeInactive] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffDTOSearchResponseResponse> {
            return localVarFp.apiVversionTimeOffSearchGet(version, term, pageNum, pageSize, sort, order, includeInactive, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for a TimeOff (request)
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffSearchMineGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffDTOSearchResponseResponse> {
            return localVarFp.apiVversionTimeOffSearchMineGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a TimeOffType by Id.
         * @param {number} id The Id of the TimeOffType to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<Int32Response> {
            return localVarFp.apiVversionTimeOffTypeIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a TimeOffType by Id.
         * @param {number} id The Id of the TimeOffType to retrieve
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypeIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffTypeResponse> {
            return localVarFp.apiVversionTimeOffTypeIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New TimeOffType.
         * @param {string} version 
         * @param {CreateTimeOffTypeCommand} [createTimeOffTypeCommand] The TimeOffType creation command containing all required properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypePost(version: string, createTimeOffTypeCommand?: CreateTimeOffTypeCommand, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffTypeResponse> {
            return localVarFp.apiVversionTimeOffTypePost(version, createTimeOffTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing TimeOffType.
         * @param {string} version 
         * @param {UpdateTimeOffTypeCommand} [updateTimeOffTypeCommand] The TimeOffType update command containing the Id and properties to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypePut(version: string, updateTimeOffTypeCommand?: UpdateTimeOffTypeCommand, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffTypeResponse> {
            return localVarFp.apiVversionTimeOffTypePut(version, updateTimeOffTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for TimeOffTypes by regimeId
         * @param {string} version 
         * @param {number} [regimeId] 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTimeOffTypeSearchGet(version: string, regimeId?: number, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<TimeOffRegimeDTOSearchResponseResponse> {
            return localVarFp.apiVversionTimeOffTypeSearchGet(version, regimeId, term, pageNum, pageSize, sort, order, f, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeoffApi - object-oriented interface
 * @export
 * @class TimeoffApi
 * @extends {BaseAPI}
 */
export class TimeoffApi extends BaseAPI {
    /**
     * 
     * @summary Gets Employee TimeOff Types by EmployeeRegime Id
     * @param {number} employeeRegimeId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeRegimeTimeOffTypeEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new EmployeeRegimeTimeOffType.
     * @param {string} version 
     * @param {CreateEmployeeRegimeTimeOffTypeCommand} [createEmployeeRegimeTimeOffTypeCommand] The EmployeeRegimeTimeOffType creation command containing all required properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeRegimeTimeOffTypePost(version: string, createEmployeeRegimeTimeOffTypeCommand?: CreateEmployeeRegimeTimeOffTypeCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeRegimeTimeOffTypePost(version, createEmployeeRegimeTimeOffTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets an EmployeeTimeOffRegime by employee ID including related EmployeeRegimeTimeOffTypes, EmployeeTimeOffStocks
     * @param {number} employeeId The ID of the employee
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet(employeeId: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRegimeEmployeeEmployeeIdGet(employeeId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an EmployeeTimeOffRegime by id. This will also soft delete all related EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
     * @param {number} id The ID of the EmployeeTimeOffRegime to delete
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRegimeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRegimeIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New EmployeeTimeOffRegime. EmployeeRegimeTimeOffTypes and EmployeeTimeOffStocks
     * @param {string} version 
     * @param {CreateEmployeeTimeOffRegimeCommand} [createEmployeeTimeOffRegimeCommand] The EmployeeTimeOffRegime creation command containing all required properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRegimePost(version: string, createEmployeeTimeOffRegimeCommand?: CreateEmployeeTimeOffRegimeCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRegimePost(version, createEmployeeTimeOffRegimeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a TimeOff\'s attached file (requires userentity header)
     * @param {string} version 
     * @param {number} [id] 
     * @param {string} [key] 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRequestFileDelete(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRequestFileDelete(version, id, key, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a TimeOff\'s attached file
     * @param {string} version 
     * @param {number} [id] 
     * @param {string} [key] 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRequestFileGet(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRequestFileGet(version, id, key, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a EmployeeTimeOffRequest by Id (requires userentity header)
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRequestIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRequestIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New EmployeeTimeOffRequest.
     * @param {string} version 
     * @param {string} [commandJson] 
     * @param {Array<File>} [uploads] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRequestPost(version: string, commandJson?: string, uploads?: Array<File>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRequestPost(version, commandJson, uploads, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an EmployeeTimeOffRequest.
     * @param {string} version 
     * @param {string} [commandJson] 
     * @param {Array<File>} [uploads] 
     * @param {Array<string>} [keysForDeletion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRequestPut(version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRequestPut(version, commandJson, uploads, keysForDeletion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches everyone\'s time offs with visible states. If client, then your employees time off.
     * @param {string} version 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [term] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {number} [userEntityId] 
     * @param {number} [employeeId] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRequestSearchGet(version: string, pageNum?: number, pageSize?: number, term?: string, sort?: string, order?: string, userEntityId?: number, employeeId?: number, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRequestSearchGet(version, pageNum, pageSize, term, sort, order, userEntityId, employeeId, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches your time offs with visible states. If client, then your employees time off.
     * @param {string} version 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffRequestSearchMineGet(version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffRequestSearchMineGet(version, pageNum, pageSize, sort, order, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an EmployeeTimeOffStock.
     * @param {string} version 
     * @param {DeleteEmployeeTimeOffStockCommand} [deleteEmployeeTimeOffStockCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffStockDelete(version: string, deleteEmployeeTimeOffStockCommand?: DeleteEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffStockDelete(version, deleteEmployeeTimeOffStockCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new EmployeeTimeOffStock.
     * @param {string} version 
     * @param {CreateEmployeeTimeOffStockCommand} [createEmployeeTimeOffStockCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffStockPost(version: string, createEmployeeTimeOffStockCommand?: CreateEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffStockPost(version, createEmployeeTimeOffStockCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a new EmployeeTimeOffStock.
     * @param {string} version 
     * @param {UpdateEmployeeTimeOffStockCommand} [updateEmployeeTimeOffStockCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEmployeeTimeOffStockPut(version: string, updateEmployeeTimeOffStockCommand?: UpdateEmployeeTimeOffStockCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEmployeeTimeOffStockPut(version, updateEmployeeTimeOffStockCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Events relevant to user.This is for Dashboard Calendar
     * @param {string} version 
     * @param {Date} [start] 
     * @param {Date} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEventAllGet(version: string, start?: Date, end?: Date, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEventAllGet(version, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for all Events. Useful for filtering events.
     * @param {string} version 
     * @param {string} [term] 
     * @param {string} [order] 
     * @param {string} [eventType] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionEventSearchGet(version: string, term?: string, order?: string, eventType?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionEventSearchGet(version, term, order, eventType, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets employee time off stock name
     * @param {number} employeeRegimeId The ID of the employee regime
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionListEmployeeTimeOffStockNameEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets employee time off types list for a specific employee regime
     * @param {number} employeeRegimeId The ID of the employee regime
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionListEmployeeTimeOffTypesEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary regime ListOptionDto
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionListRegimeGet(version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionListRegimeGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary requestType ListOptionDto
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionListRequestTypeGet(version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionListRequestTypeGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets time off types list for a specific employee regime  Returns TimeOffType.Id instead of EmployeeRegimeTimeOffType.Id
     * @param {number} employeeRegimeId The ID of the employee regime
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionListTimeOffTypesByEmployeeRegimeEmployeeRegimeIdGet(employeeRegimeId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of time off types grouped by their regimes
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionListTimeOffTypesByRegimeGet(version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionListTimeOffTypesByRegimeGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the list of all NonWorkingDays
     * @param {string} version 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionNonWorkingDayAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionNonWorkingDayAllGet(version, pageNum, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a NonWorkingDay by Id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionNonWorkingDayIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionNonWorkingDayIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets an NonWorkingDay by id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionNonWorkingDayIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionNonWorkingDayIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New NonWorkingDay.
     * @param {string} version 
     * @param {CreateNonWorkingDayCommand} [createNonWorkingDayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionNonWorkingDayPost(version: string, createNonWorkingDayCommand?: CreateNonWorkingDayCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionNonWorkingDayPost(version, createNonWorkingDayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a NonWorkingDay.
     * @param {string} version 
     * @param {UpdateNonWorkingDayCommand} [updateNonWorkingDayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionNonWorkingDayPut(version: string, updateNonWorkingDayCommand?: UpdateNonWorkingDayCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionNonWorkingDayPut(version, updateNonWorkingDayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for NonWorkingDays
     * @param {string} version 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionNonWorkingDaySearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionNonWorkingDaySearchGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a TimeOff\'s attached file (requires userentity header)
     * @param {string} version 
     * @param {number} [id] 
     * @param {string} [key] 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffFileDelete(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffFileDelete(version, id, key, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a TimeOff\'s attached file
     * @param {string} version 
     * @param {number} [id] 
     * @param {string} [key] 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffFileGet(version: string, id?: number, key?: string, employeeId?: number, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffFileGet(version, id, key, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a TimeOff by id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a TimeOff by Id (requires userentity header)
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New TimeOff.
     * @param {string} version 
     * @param {string} [commandJson] 
     * @param {Array<File>} [uploads] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffPost(version: string, commandJson?: string, uploads?: Array<File>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffPost(version, commandJson, uploads, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing TimeOff.
     * @param {string} version 
     * @param {string} [commandJson] 
     * @param {Array<File>} [uploads] 
     * @param {Array<string>} [keysForDeletion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffPut(version: string, commandJson?: string, uploads?: Array<File>, keysForDeletion?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffPut(version, commandJson, uploads, keysForDeletion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets an existing TimeOffRegime to Active.
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffRegimeIdActivatePatch(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffRegimeIdActivatePatch(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing TimeOffRegime.
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffRegimeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffRegimeIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a TimeOffRegime by Id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffRegimeIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffRegimeIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New TimeOffRegime.
     * @param {string} version 
     * @param {CreateTimeOffRegimeCommand} [createTimeOffRegimeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffRegimePost(version: string, createTimeOffRegimeCommand?: CreateTimeOffRegimeCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffRegimePost(version, createTimeOffRegimeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing TimeOffRegime.
     * @param {string} version 
     * @param {UpdateTimeOffRegimeCommand} [updateTimeOffRegimeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffRegimePut(version: string, updateTimeOffRegimeCommand?: UpdateTimeOffRegimeCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffRegimePut(version, updateTimeOffRegimeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for TimeOffRegimes
     * @param {string} version 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffRegimeSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffRegimeSearchGet(version, term, pageNum, pageSize, sort, order, includeInactive, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the list of all TimeOffRequestTypes
     * @param {string} version 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffRequestTypeAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffRequestTypeAllGet(version, pageNum, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for a TimeOff (request)
     * @param {string} version 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, includeInactive?: boolean, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffSearchGet(version, term, pageNum, pageSize, sort, order, includeInactive, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for a TimeOff (request)
     * @param {string} version 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffSearchMineGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffSearchMineGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a TimeOffType by Id.
     * @param {number} id The Id of the TimeOffType to delete
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffTypeIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffTypeIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a TimeOffType by Id.
     * @param {number} id The Id of the TimeOffType to retrieve
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffTypeIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffTypeIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New TimeOffType.
     * @param {string} version 
     * @param {CreateTimeOffTypeCommand} [createTimeOffTypeCommand] The TimeOffType creation command containing all required properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffTypePost(version: string, createTimeOffTypeCommand?: CreateTimeOffTypeCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffTypePost(version, createTimeOffTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing TimeOffType.
     * @param {string} version 
     * @param {UpdateTimeOffTypeCommand} [updateTimeOffTypeCommand] The TimeOffType update command containing the Id and properties to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffTypePut(version: string, updateTimeOffTypeCommand?: UpdateTimeOffTypeCommand, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffTypePut(version, updateTimeOffTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for TimeOffTypes by regimeId
     * @param {string} version 
     * @param {number} [regimeId] 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeoffApi
     */
    public apiVversionTimeOffTypeSearchGet(version: string, regimeId?: number, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return TimeoffApiFp(this.configuration).apiVversionTimeOffTypeSearchGet(version, regimeId, term, pageNum, pageSize, sort, order, f, options).then((request) => request(this.axios, this.basePath));
    }
}

